import _ from 'lodash';
import { Button, List, Modal, Row, Col, Tag } from 'antd';

const ProcessNotProcessed = ({
  items,
  selectedRowKeys,
  handleProcessModal,
  cancelProcessModal,
  openProcessModal,
  processingLoading,
  processNotProcessed,
  tagColor
}) => {
  return (
    <>
      <Button
        disabled={!selectedRowKeys.length}
        type="primary"
        size="large"
        onClick={handleProcessModal}>
        Procesar
      </Button>
      <Modal
        title="Procesar"
        footer={false}
        width={800}
        onCancel={cancelProcessModal}
        visible={openProcessModal}>
        <p>
          Notificarás la prefactura a estás {selectedRowKeys.length} empresas:
      </p>

        <List>
          {items && items.length && selectedRowKeys.map(key => {
            const item = _.find(items, { id: key });
            return (
              <List.Item>
                <span style={{ display: 'inline-block', width: 400 }}>{item.company_name}</span>
                <Tag color={tagColor(item.agreement_type)}>{item.agreement_type}</Tag>
              </List.Item>
            )
          })}
        </List>

        <Row justify="end" className="mt-40">
          <Col>
            <Button
              loading={processingLoading}
              onClick={processNotProcessed}
              size="large"
              type="primary">
              Procesar
          </Button>
          </Col>
        </Row>
      </Modal>
    </>
  )
}

export default ProcessNotProcessed;